import { reportsItems } from "@/consts/Reports";
import { StaffAccessLevels } from "@/enums/StaffAccessLevels";

export default {
  name: "ReportList",
  data() {
    return {
      currentDate: new Date().getDate(),
      search: "",
      reports: [],
      staffAccessLevels: StaffAccessLevels,
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: false,
          value: "name"
        }
      ]
    }
  },
  created() {
    const reportsItemsCopy = JSON.parse(JSON.stringify(reportsItems))

    this.reports = reportsItemsCopy.filter(x => x.accessLevels?.length?x.accessLevels.includes(this.user.accessLevel):true)

    this.reports = this.reports.map(x => {
      const r = x
      r.name = this.$i18n.messages[this.$i18n.locale][x.name]
      return r
    });
     
  },
  methods: {
    openReport(route) {
      this.$router.push("/reports/" + route);
    }
  },
  computed: {
    user() {
      return this.$store.state.authModule.user;
    },
    isMaintenanceAdmin() {
      return this.user.accessLevel === StaffAccessLevels.MaintenanceAdmin;
    }
  }
}
